module.exports = __webpack_public_path__ + "./img/learn-more-pac-img.svg";